import { createElementVNode as _createElementVNode, renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/img/logo/logo_login.png'


const _withScopeId = n => (_pushScopeId("data-v-1b171a86"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "megaSpinner" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _renderSlot(_ctx.$slots, "default", {}, undefined, true)
  ]))
}